/** The subset of a Radio Browser station object the game reads. */
export interface RadioBrowserStationDTO {
  stationuuid: string;
  name: string;
  url: string;
  url_resolved: string;
  homepage: string;
  favicon: string;
  /** Comma-separated, not a `string[]`. */
  tags: string;
  /** ISO 3166-1 alpha-2. */
  countrycode: string;
  language: string;
  /** For example MP3, AAC, AAC+. */
  codec: string;
  /** As reported by the directory, typically kbit/s. */
  bitrate: number;
  hls: 0 | 1;
  lastcheckok: 0 | 1;
  votes: number;
  clickcount: number;
}

/** A validated, playable-candidate station. */
export interface RadioStation {
  /** The provider's `stationuuid`; numeric ids are not stable across mirrors. */
  id: string;
  name: string;
  /** Validated `url_resolved`, always `https:`. */
  streamUrl: string;
  logoUrl: string | null;
  countryCode: string | null;
  tags: string[];
  codec: string;
  bitrateKbps: number | null;
}

/** The synchronized, server-authoritative radio state (desired, not actual, playback). */
export interface RadioSnapshot {
  playing: boolean;
  /** `stationuuid`; "" when nothing was ever tuned. */
  stationId: string;
  stationName: string;
  streamUrl: string;
  codec: string;
  bitrateKbps: number;
  logoUrl: string;
  countryCode: string;
  /** Nickname of the player who made the last change. */
  tunedBy: string;
  /** Epoch ms of the last change. */
  changedAt: number;
}

export const RADIO_OFF: RadioSnapshot = {
  playing: false,
  stationId: "",
  stationName: "",
  streamUrl: "",
  codec: "",
  bitrateKbps: 0,
  logoUrl: "",
  countryCode: "",
  tunedBy: "",
  changedAt: 0,
};
